import type { FlowVariable } from '@/features/negociacaoIndividualWizard';
import {
  isAutoMappedNegotiacaoVariable,
  parametroObrigatorioPreenchido,
} from '@/shared/utils/agentVariables';

import type { ErroDaSimulacao, ParametrosDaSimulacao } from '../types';

const MENSAGEM_DO_CAMPO_INVALIDO = 'Confira este campo.';

/**
 * A simulação não pede o que o core preenche sozinho no início (`claimAmount` e os outros auto
 * mapeados), mesmo que o catálogo o projete para o lote (CA-3 do cliente; CA-11 do admin).
 */
export const camposVisiveisDoInicio = (variaveisDoAgente: FlowVariable[]): FlowVariable[] =>
  variaveisDoAgente.filter((variavel) => !isAutoMappedNegotiacaoVariable(variavel.name));

/** Os padrões do agente, inclusive dos auto mapeados: o core os recebe no início. */
export const valoresPadraoDoAgente = (variaveisDoAgente: FlowVariable[]): ParametrosDaSimulacao =>
  Object.fromEntries(
    variaveisDoAgente
      .filter((variavel) => variavel.defaultValue !== undefined)
      .map((variavel) => [variavel.name, variavel.defaultValue]),
  );

export const obrigatoriosPreenchidos = (
  campos: FlowVariable[],
  valores: ParametrosDaSimulacao,
): boolean => campos.every((campo) => parametroObrigatorioPreenchido(campo, valores[campo.name]));

/** O `AgentParametersFields` liga o erro ao campo pela chave `agent_<nome>`. */
export const errosDosCamposDoInicio = (erroDoInicio: ErroDaSimulacao | null) =>
  Object.fromEntries(
    (erroDoInicio?.camposInvalidos ?? []).map((campo) => [
      `agent_${campo}`,
      MENSAGEM_DO_CAMPO_INVALIDO,
    ]),
  );
